<div class="tooltip_skeleton">
  <div class="input_skeleton"></div>
  <div class="buttons_skeleton">
    <div class="button_skeleton"></div>
    <div class="button_skeleton"></div>
  </div>
</div>
